export function ageFromDateOfBirth(dateOfBirth: string): number {
  const birth = new Date(dateOfBirth);
  if (Number.isNaN(birth.getTime())) return 25;

  const today = new Date();
  let age = today.getFullYear() - birth.getFullYear();
  const monthDelta = today.getMonth() - birth.getMonth();
  if (monthDelta < 0 || (monthDelta === 0 && today.getDate() < birth.getDate())) {
    age -= 1;
  }
  return Math.max(18, age);
}

export function getAgeRangeDescription(minAge: number, maxAge: number, userAge: number): string {
  const minDiff = minAge - userAge;
  const maxDiff = maxAge - userAge;

  if (minDiff >= 0 && maxDiff > 0) {
    return `${minDiff} to ${maxDiff} ${maxDiff === 1 ? "year" : "years"} older than you (${userAge})`;
  }

  if (minDiff < 0 && maxDiff <= 0) {
    const minYounger = Math.abs(maxDiff);
    const maxYounger = Math.abs(minDiff);
    return `${minYounger} to ${maxYounger} ${maxYounger === 1 ? "year" : "years"} younger than you (${userAge})`;
  }

  const younger = Math.abs(minDiff);
  const older = maxDiff;
  return `${younger} ${younger === 1 ? "year" : "years"} younger to ${older} ${older === 1 ? "year" : "years"} older than you (${userAge})`;
}
